!(function(t) {
    'use strict';
    var e = t.HTMLCanvasElement && t.HTMLCanvasElement.prototype,
        o =
            t.Blob &&
            (function() {
                try {
                    return Boolean(new Blob());
                } catch (t) {
                    return !1;
                }
            })(),
        n =
            o &&
            t.Uint8Array &&
            (function() {
                try {
                    return 100 === new Blob([new Uint8Array(100)]).size;
                } catch (t) {
                    return !1;
                }
            })(),
        r =
            t.BlobBuilder ||
            t.WebKitBlobBuilder ||
            t.MozBlobBuilder ||
            t.MSBlobBuilder,
        a = /^data:((.*?)(;charset=.*?)?)(;base64)?,/,
        i =
            (o || r) &&
            t.atob &&
            t.ArrayBuffer &&
            t.Uint8Array &&
            function(t) {
                var e, i, l, u, b, c, d, B, f;
                if (((e = t.match(a)), !e)) throw new Error('invalid data URI');
                for (
                    (i = e[2]
                        ? e[1]
                        : 'text/plain' +
                              (e[3] ||
                                  ';charset=US-ASCII')), (l = !!e[4]), (u = t.slice(
                        e[0].length
                    )), (b = l
                        ? atob(u)
                        : decodeURIComponent(u)), (c = new ArrayBuffer(
                        b.length
                    )), (d = new Uint8Array(c)), (B = 0);
                    B < b.length;
                    B += 1
                )
                    d[B] = b.charCodeAt(B);
                return o
                    ? new Blob([n ? d : c], { type: i })
                    : ((f = new r()), f.append(c), f.getBlob(i));
            };
    t.HTMLCanvasElement &&
        !e.toBlob &&
        (e.mozGetAsFile
            ? (e.toBlob = function(t, o, n) {
                  t(
                      n && e.toDataURL && i
                          ? i(this.toDataURL(o, n))
                          : this.mozGetAsFile('blob', o)
                  );
              })
            : e.toDataURL &&
                  i &&
                  (e.toBlob = function(t, e, o) {
                      t(i(this.toDataURL(e, o)));
                  })), 'function' == typeof define && define.amd
        ? define(function() {
              return i;
          })
        : 'object' == typeof module && module.exports
              ? (module.exports = i)
              : (t.dataURLtoBlob = i);
})(window);
//# sourceMappingURL=canvas-to-blob.min.js.map
